var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.loading ? _c("loading-indicator") : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass: "link-preview-card",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openLink.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "link-preview-card__image",
                attrs: { src: _vm.image, alt: "Link Thumbnail" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "link-preview-card__title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "link-preview-card__description" }, [
                _vm._v(_vm._s(_vm.description)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "link-preview-card__domain" }, [
                _vm._v(_vm._s(_vm.domain)),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }